/**
 * Single chokepoint for GA4-bound dataLayer pushes (SPEC-027 FR-3).
 *
 * Every GA4 event goes through here so the `client_id` / `session_id` /
 * `user_id` triple is merged uniformly. Null identifiers (anonymous users
 * with capture blocked) are omitted per decision D1.
 */
import { getGa4Identifiers } from './ga4Identifiers'

const pushGa4Event = (event, params = {}, userId) => {
  const ids = getGa4Identifiers(userId)
  const cleanedIds = Object.fromEntries(
    Object.entries(ids).filter(([, value]) => value != null)
  )
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    ...params,
    ...cleanedIds // client_id (string), session_id (number), user_id (string)
  })
}

export default pushGa4Event
